import { GameConfig } from '../../domain/entities';

export const womensGameConfig: GameConfig = {
    LEAGUE_NAMES: ["Super Division", "First Division"],
    WEEKS_PER_SEASON: 35,
    LEAGUE_CONFIG: {
        "Super Division": { teams: 12, promotion: 0, relegation: 1 },
        "First Division": { teams: 12, promotion: 1, relegation: 0 },
    },
    PRIZE_MONEY: {
        "Super Division": { positions: [50000000, 40000000, 30000000] },
        "First Division":   { promotion: 10000000 },
    },
    CUP_NAMES: ['Womens Pixel Cup', 'Womens League Cup'],
    CUP_CONFIG: {
        'Womens Pixel Cup': {
            name: 'Womens Pixel Cup',
            prizeMoney: [1280000, 2560000, 5120000, 10240000, 20480000],
            tvMoneyPerGame: 750000,
        },
        'Womens League Cup': {
            name: 'Womens League Cup',
            prizeMoney: [2400000, 4800000, 12000000, 24000000],
            tvMoneyPerGame: 300000,
        }
    },
};